import React, { useState, useContext, useEffect } from 'react';
import { useParams, useNavigate } from "react-router-dom";
import {localizeKey, localizeArt} from './../localize.js';
import axiosInstance from './../axiosInstance.js';
import MyUserContext from './../myUserContext.js';
import Collapsible from './Collapsible';
import { Link } from 'react-router-dom';
import CardEventArtChat from './CardEventArtChat';
import { Helmet } from 'react-helmet';

// eventType: "artEvent", "recommendation"
const ArtEvent = ({eventType, eventId}) => {
  const { id: paramId } = useParams();
  const id = eventId || paramId;
  const myUser = useContext(MyUserContext);
  const [artEvent, setArtEvent] = useState(null);
  const [privateAcc, setPrivateAcc] = useState(false);

  useEffect(() => {
    if (artEvent && id !== artEvent.event.id) {
      updateArtEvent();
    }
  }, [id]);

  useEffect(() => {
    const previousOverflow = document.body.style.overflow;
    document.body.classList.add("artevent-page");
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = previousOverflow;
      document.body.classList.remove("artevent-page");
    };
  }, []);

  // TODO: do not explicitly set fields in setArtEvent
  const updateArtEvent = () => {
    if (eventType === 'recommendation') { // it will live, or not
      axiosInstance
      .get(`/recommendations/${id}`)
      .then((response) => {
        setArtEvent({
          event: response.data.recommendation,
          art: response.data.art,
          fromUser: response.data.fromUser,
          toUser: response.data.toUser,
          chat: response.data.chat,
        });
      })
      .catch((error) => {
        console.error(error);
      });
      return;
    }

    if (eventType === 'artEvent') {
      axiosInstance
      .get(`/artEvents/${id}`)
      .then((response) => {
        setArtEvent({
          event: response.data.event,
          art: response.data.art,
          chat: response.data.chat,
          eventOwnerUserName: response.data.eventOwnerUserName,
          eventOwnerUserAvatarUrl: response.data.eventOwnerUserAvatarUrl
        });
      })
      .catch((error) => {
        if (error.response) {
          if (error.response.status === 403 || error.response.status === 401) {
            setPrivateAcc(true);
          } else {
            console.error('Error: ', error.response.data);
          }
        } else {
          console.error(error);
        }
      });
      return;
    }
  };

  // awaitUpdateArtEvent();

  const language = myUser ? myUser.myUserSettings.lang : 'ru';

  if (privateAcc === true) {
    return (
      <div className="mt-2 flex justify-center text-center">
        {language === "ru" ? "Вы патаетесь посмотреть добавленное в приватном аккаунте, подпишитесь на пользователя и дождитесь подтверждения" : "You are trying to see a record in the private account, subscribe to the user and wait for their approval"}
      </div>
    )
  }

  if (artEvent === null) {
    updateArtEvent();
    return (
      <div>
      </div>
    )
  }

  // if (eventType === "todo") {
  //   return <div>To be implemented</div>
  // }

  let actualEventType = eventType;
  if (eventType === "artEvent") {
    if (artEvent.event.type === 1) {
      actualEventType = "finished"; // not relevant
    } else if (artEvent.event.type === 2) {
      actualEventType = "todo"; // not relevant
    } else if (artEvent.event.type === 3) {
      actualEventType = "like"; // always this
    }
  } // else it's recommendation

  return (
    <div
      key={artEvent.event.id}
      className="flex h-[100dvh] min-h-0 flex-col overflow-hidden"
      style={{
        paddingTop: "var(--artevent-pad-top)"
      }}
    >
      <CardEventArtChat
        chatState={"shown"} 
        event={artEvent.event} 
        chatInfo={artEvent.chat} 
        userInfo={{name:artEvent.eventOwnerUserName, avatarUrl: artEvent.eventOwnerUserAvatarUrl}} 
        eventType={actualEventType} 
        art={artEvent.art} 
        misc={{fromUser: artEvent.fromUser, toUser: artEvent.toUser}} 
        language={language} 
        chatFillHeight={true}
      />
    </div>
  );
}

export default ArtEvent;
